export default __webpack_public_path__ + "static/media/travel insurance consultants canada.18072491.jpg";